module.exports = __webpack_public_path__ + "static/media/black_time_of_day.37ca2eda.svg";